import { createContext } from 'react'

import { FlowContextProps } from './types'

const defaultError = () => {
  throw new Error('You must define a `FlowProvider` to use `FlowContext`.')
}

export const FlowContext = createContext<FlowContextProps>({
  isInProgress: false,
  isLoading: false,
  error: undefined,
  complete: defaultError,
  skipBlocker: defaultError,
  //start methods
  startWithBlockerDescriptors: defaultError,
  startWithClientScenario: defaultError,
  startWithResponse: defaultError,
  startWithFlow: defaultError,
  //update methods
  updateWithBlockerDescriptors: defaultError,
  updateWithClientScenario: defaultError,
  updateWithResponse: defaultError,
  updateWithFlow: defaultError,
  reset: defaultError,
  suspend: defaultError,
  restore: defaultError,
  cancel: defaultError,
  loadUrl: defaultError,
  executeBlockerAction: defaultError,
  closeBlockerAction: defaultError,
})
